
import React from 'react';
import Grocerybasicreport from "./importrapages/Grocerybasicreport";
import Grocerystandardreport from "./importrapages/Grocerystandardreport";



const Groceryanalysis = ({ plan }) => {

  const subscriptionPlan = plan || localStorage.getItem("planType") || "standard";

  switch (subscriptionPlan.toLowerCase()) {
    case "basic":
      return <Grocerybasicreport />;
    case "standard":
      return <Grocerybasicreport />;
    case "premium":
      return <Grocerybasicreport />;
    default:
      return <div>Invalid plan selected</div>;
  }
};

export default Groceryanalysis;